import ReactGA from 'react-ga4'

export enum EventOrigin {
  button = 'button',
  modal = 'modal',
  select = 'select',
  input = 'input'
}

export enum EventGoal {
  submit = 'submit',
  filter = 'filter',
  applyFilter = 'apply_filter',
  clearFilter = 'clear_filter',
  download = 'download',
  cancel = 'cancel',
  closeModal = 'close_modal',
  openModal = 'open_modal',
  openPopover = 'open_popover',
  click = 'click',
  navigation = 'navigation',
  upload = 'upload',
  success = 'success',
  error = 'error'
}

interface EventParams {
  origin?: EventOrigin
  goal?: EventGoal
}

interface EventProps {
  name: string
  params: EventParams
}

const reactGA = (
  typeof (ReactGA as { initialize?: unknown })?.initialize === 'function'
    ? ReactGA
    : (ReactGA as unknown as { default: typeof ReactGA }).default
) as typeof ReactGA

export const logEvent = (event: EventProps): void => {
  reactGA.event(event.name, {
    origin: event.params.origin,
    goal: event.params.goal
  })
}
